import styled from "styled-components";

import { Container, TextField } from "@mui/material";

export const FormContainer = styled(Container)`
   
   form {
    display: flex;
    flex-direction: column;
    align-items: left;
    color: ${({ theme }) => theme.COLORS.BLUE};
    font-family: 'Mont-Medium'; 

    .mensagem {
      font-size: clamp(1.8rem,  4vw, 2rem) !important; 
      margin-top: 1.6rem;
      text-align: left;

      small {
        font-size: 1.2rem;
        margin-left: .4rem;
      }
    }
   }
`;


export const FieldWrapper = styled.div`
   margin-bottom: 1rem;
`;


export const FormField = styled(TextField)`
width: 100%;

.MuiInputLabel-root {
  color: ${({ theme }) => theme.COLORS.BLUE};
  font-size: clamp(1.8rem,  4vw, 2rem) !important; 
  font-family: 'Mont-Medium'; 
};

.MuiInputLabel-root.Mui-focused {
  color: ${({ theme }) => theme.COLORS.BLUE};
};

.MuiInputBase-root {
  font-family: 'Mont-Light'; 
  font-size: 1.6rem;
  color: ${({ theme }) => theme.COLORS.DARKGREY};
}


.MuiInput-underline {
  &:after {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHTBLUE2};

  }

  &.Mui-focused:after {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BLUE};
  }

  &:before {
    border-bottom: 1px solid  ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  &:hover:not(.Mui-disabled):before {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.BLUE};
  }
}
`;


export const TextAreaWrapper = styled.div`
border: 1px solid ${({ theme }) => theme.COLORS.LIGHTBLUE2};
margin-top: .2rem;

&:hover {
  border: 1px solid ${({ theme }) => theme.COLORS.BLUE};
}

&:focus-within {
  border: 1px solid ${({ theme }) => theme.COLORS.BLUE};
  }
`;


export const FormTextArea = styled.textarea`
  width: 100%;
  height: 8rem;
  padding: 1rem;

  border: none;
  outline: none;
  resize: none;


  font-family: 'Mont-Light'; 
  color: ${({ theme }) => theme.COLORS.DARKGREY};
  font-size: 1.6rem;

  
`;


export const ButtonWrapper = styled.div`
text-align: center;
`;


export const FormButton =styled.button`
    padding: 1.3rem 15%;
    border: none;
    border-radius: 999px;
    margin-top: 3rem;
    margin-left: auto;
    margin-right: auto;

    background-color:${({ theme }) => theme.COLORS.YELLOW};
    color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    font-size: clamp(2.6rem, 2vw, 4rem);
    font-family: 'Nexa-Bold'; 
    letter-spacing: 2px;

    transition: all .2s;
    
    &:hover {
        background-color:${({ theme }) => theme.COLORS.LIGHTBLUE2};
        color: ${({ theme }) => theme.COLORS.YELLOW};
    }
    
`;